

















































































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { ImageFile } from '@/types/image'
import { ImageFilePayload } from '@/api/dicom/types'
import FileInput from '@/components/common/inputs/FileInput.vue'

@Component({
  components: {
    FileInput,
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  },
  filters: {
    formatDate(dateString: string) {
      const date = new Date(dateString)
      return date.toLocaleString()
    }
  }
})
export default class DicomEdit extends Vue {
  $store!: ExStore
  dicom: ImageFile | null = null
  base64 = ''
  fileSelect = false
  loading = false

  get patientId() {
    return Number(this.$route.params.patientId)
  }

  get dicomId() {
    return Number(this.$route.params.dicomId)
  }

  async fetchDicom() {
    try {
      const res = await this.$api.dicom.fetchOne({
        patientId: this.patientId,
        dicomId: this.dicomId
      })
      this.dicom = res
    } catch (e) {
      if (e.message === 'Not Found') {
        this.$router.replace({ name: 'DocumentTabIndex' })
      }
    }
  }

  async upload() {
    this.loading = true
    try {
      const payload: Partial<ImageFilePayload> = {
        title: this.dicom?.title,
        description: this.dicom?.description,
        fileName: this.dicom?.fileName
      }

      if (this.base64) {
        payload.fileContent = this.base64
      }

      await this.$api.dicom.patch({
        patientId: this.patientId,
        dicomId: this.dicomId,
        payload
      })
      this.$router.push({
        name: 'DicomTabIndex'
      })
      this.loading = false
    } catch (e) {
      console.error(e)
      this.loading = false
    }
  }

  async created() {
    await this.fetchDicom()
  }
}
